module.exports = __webpack_public_path__ + "img/bj_left.9b22ef0a.png";